export default () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', playPauseVideo);
  } else {
    playPauseVideo();
  }
  
  function playPauseVideo() {
    const videoWrapper = document.querySelectorAll('[data-video-wrapper]');
  
    videoWrapper.forEach((wrapper) => {
      const video = wrapper.querySelector('[data-video]')
      const playIcon = wrapper.querySelector('[data-play-icon]');
      const pauseIcon = wrapper.querySelector('[data-pause-icon]');

      playIcon.addEventListener('click', () => {
        video.play();
        wrapper.classList.toggle('video--playing');
      });
    
      pauseIcon.addEventListener('click', () => {
        video.pause();
        wrapper.classList.toggle('video--playing');
      });
    })
  }  
}